import { useState, useEffect } from "react";
import api from "../../api/axios";
import Swal from "sweetalert2";
import "../../assets/css/Users/UsersCreate.css";

import {
  FaUser,
  FaEnvelope,
  FaUserShield,
  FaUserTie,
} from "react-icons/fa";

export default function UsersCreate({ onClose, onSuccess }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    manager_id: "",
    role: "",
  });

  const roleOptions = [
    { value: "", label: "Select Role" },
    { value: "Super Admin", label: "Super Admin" },
    { value: "Sales Manager", label: "Sales Manager" },
    { value: "Sales Executive", label: "Sales Executive" },

  ];
  const [users, setUsers] = useState([]);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  //error validation
const [loading, setLoading] = useState(false);

const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};


  const [errors, setErrors] = useState({});

  const isBlank = (val) => !val || String(val).trim() === "";

  const isValidURL = (url) => {
    if (!url) return true; // website optional

    try {
      const parsed = new URL(url);
      return ["http:", "https:"].includes(parsed.protocol);
    } catch {
      return false;
    }
  };


  const validate = () => {
    const newErrors = {};

    // NAME
    if (isBlank(form.name)) {
      newErrors.name = "Name is required";
    } else if (form.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    // EMAIL
    if (isBlank(form.email)) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(form.email)) {
      newErrors.email = "Enter a valid email address";
    }

    // ROLE
    if (isBlank(form.role)) {
      newErrors.role = "Role is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  const handleBlur = (e) => {
    const { name, value } = e.target;

    let error = "";

    if (name === "name") {
      if (isBlank(value)) error = "Name is required";
      else if (value.trim().length < 3)
        error = "Name must be at least 3 characters";
    }

    if (name === "email") {
      if (isBlank(value)) error = "Email is required";
      else if (!isValidEmail(value))
        error = "Enter a valid email address";
    }

    if (name === "role") {
      if (isBlank(value)) error = "Role is required";
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  //fetch iser
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get("/users");
        setUsers(res.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchUsers();
  }, []);

  const submit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      await api.post("/users", {
        name: form.name.trim(),
        email: form.email.trim(),
        manager_id: form.manager_id ? Number(form.manager_id) : null,
        role: form.role,
      });

      await Swal.fire({
        icon: "success",
        title: "User Created",
        timer: 1200,
        showConfirmButton: false,
      });

      onSuccess?.();
      onClose?.();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.detail || "Failed to create user",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="users-create-modal__overlay" onClick={onClose}>
      <div
        className="users-create-modal__card"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="users-create-modal__header">
          <h3 className="users-create-modal__title">Create User</h3>
          <button
            className="users-create-modal__close-btn"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <form onSubmit={submit} className="users-create-modal__body">
          <div className="users-create-modal__grid">

            {/* NAME */}
            <div className="users-create-modal__group">
              <label>Name</label>
              <div className="users-create-modal__input-wrapper">
                <FaUser className="users-create-modal__icon" />
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter full name"
                  required
                />
              </div>
              {errors.name && (
  <small className="error-text">{errors.name}</small>
)}
            </div>

            {/* EMAIL */}
            <div className="users-create-modal__group">
              <label>Email</label>
              <div className="users-create-modal__input-wrapper">
                <FaEnvelope className="users-create-modal__icon" />
                <input
                  name="email"
                  value={form.email}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  placeholder="user@company.com"
                  required
                />
              </div>
              {errors.email && (
  <small className="error-text">{errors.email}</small>
)}
            </div>

            {/* ROLE */}
            <div className="users-create-modal__group">
              <label>Role</label>
              <div className="users-create-modal__input-wrapper">
                <FaUserShield className="users-create-modal__icon" />
                <select
                  name="role"
                  value={form.role}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {roleOptions.map((r) => (
                    <option key={r.value} value={r.value} disabled={r.value === ""}>
                      {r.label}
                    </option>
                  ))}
                </select>

                
              </div>

              {errors.role && (
                  <small className="error-text">{errors.role}</small>
                )}
            </div>

            {/* MANAGER ID */}
            <div className="users-create-modal__group">
              <label>Manager </label>
              <div className="users-create-modal__input-wrapper">
                <FaUserTie className="users-create-modal__icon" />
                <select
                  name="manager_id"
                  value={form.manager_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Manager</option>

                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

          </div>

          {/* ACTIONS */}
          <div className="users-create-modal__actions">
            <button
              type="button"
              className="users-create-modal__btn users-create-modal__btn--secondary"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="users-create-modal__btn users-create-modal__btn--primary"
            >
              Save User
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}